<div class="twc-d-flex flex-direction-column twc-m-2 container">
    <div class="twc-mt-1 twc-mb-4" *ngIf="subtitle">{{subtitle | translate}}</div>

    <h3 class="twc-h3">{{'SCANPROC.SCAN_PROCESSING_CONFIGURATION' | translate}}</h3>

    <div class="scan-processing-tables twc-mb-2">
        <cw-list-selection *ngIf="listItems?.length" [items]="listItems" (elementsSelect)="onSelectedElements($event)"
            [allSelectionLabel]="'SCANPROC.SELECT_ALL_SCANS'">
        </cw-list-selection>

        <form [formGroup]="scanProcessingOptionsService.scanProcessingForm">
            <div>
                <div>
                    <strong>{{'SCANPROC.POINTCLOUDS' | translate}}</strong>
                </div>

                <twc-checkbox class="twc-mt-2 twc-mb-2">
                    <input twcCheckboxInput type="checkbox" formControlName="processPointcloud">
                    <label twcCheckboxLabel> {{'SCANPROC.PROCESS_POINTCLOUDS' | translate}} </label>
                </twc-checkbox>

                <div class="twc-form-label">{{'UPLOAD.POINTCLOUD_QUALITY_SELECT' | translate}}</div>

                <div class="twc-d-flex twc-col-6 twc-p-0">
                    <twc-select #highQualityPointcloud [placeholder]="'UPLOAD.POINTCLOUD_QUALITY_SELECT' | translate"
                        formControlName="highQualityPointcloud">
                        <twc-select-option [value]="false">
                            {{ 'UPLOAD.POINTCLOUD_QUALITY_STANDARD' | translate}}
                        </twc-select-option>
                        <twc-select-option [value]="true">
                            {{ 'UPLOAD.POINTCLOUD_QUALITY_BEST' | translate}}
                        </twc-select-option>
                    </twc-select>
                </div>
            </div>

            <div class="twc-mt-5 twc-mb-2 twc-col-6 twc-col-sm-6">
                <div><strong>{{'SCANPROC.SCAN_PROCESSING_OPTIONS' | translate}}</strong></div>

                <div class="twc-d-flex">
                    <div class="twc-mr-4">
                        <label class="twc-form-label">{{'SCANPROC.SCAN_PRECISION' | translate}}</label>
                        <input type="number" class="twc-input" formControlName="precision"
                            placeholder="{{'SCANPROC.SCAN_PRECISION' | translate}}" step="0.001">
                    </div>
                    <div>
                        <label class="twc-form-label">{{'SCANPROC.SCAN_DENSITY' | translate}}</label>
                        <input type="number" class="twc-input" formControlName="density"
                            placeholder="{{'SCANPROC.SCAN_DENSITY' | translate}}" step="0.001">
                    </div>
                </div>
            </div>

            <div class="twc-mt-4">
                <div class="twc-mt-4 twc-d-flex align-center">
                    <div class="twc-col-5 twc-pl-0">
                        <twc-checkbox>
                            <input twcCheckboxInput type="checkbox" [cwDisableControl]="!hasToProcessPointcloud()"
                                formControlName="maxDistanceEnabled">
                            <label twcCheckboxLabel>
                                {{'SCANPROC.MAX_DISTANCE' | translate}}
                            </label>
                        </twc-checkbox>
                    </div>

                    <input class="twc-input twc-col-3" formControlName="maxDistanceValue" type="number" step="1" min="0"
                        [max]="maxValidDistance"
                        [cwDisableControl]="!hasToProcessPointcloud() || !isEnabledLimitDistance">
                    <div *ngIf="scanProcessingOptionsService.scanProcessingForm.controls['maxDistanceValue'].invalid"
                        class="twc-ml-4 twc-message-box twc-message-box-error">
                        <ng-container
                            *ngIf="scanProcessingOptionsService.scanProcessingForm.controls['maxDistanceValue'].errors?.required">
                            {{'SCANPROC.WARN_EMPTY' | translate }}
                        </ng-container>
                        <ng-container
                            *ngIf="scanProcessingOptionsService.scanProcessingForm.controls['maxDistanceValue'].errors?.min">
                            {{'SCANPROC.WARN_MIN_DIST' | translate}}
                        </ng-container>
                        <ng-container
                            *ngIf="scanProcessingOptionsService.scanProcessingForm.controls['maxDistanceValue'].errors?.max">
                            {{'SCANPROC.WARN_MAX_DIST' | translate : {maxValue: maxValidDistance} }}
                        </ng-container>
                    </div>
                </div>

                <div class="twc-mt-4 twc-d-flex align-center">
                    <div class="twc-col-5 twc-pl-0">
                        <twc-checkbox>
                            <input twcCheckboxInput type="checkbox" formControlName="edgeNoiseReduction"
                                [cwDisableControl]="!hasToProcessPointcloud()">
                            <label twcCheckboxLabel> {{'SCANPROC.EDGE_NOISE_REDUCT' | translate}} </label>
                        </twc-checkbox>
                    </div>

                    <twc-select [placeholder]="'SCANPROC.EDGE_NOISE_REDUCT' | translate"
                        formControlName="edgeNoiseReductionLevel" class="twc-col-3 twc-p-0"
                        [cwDisableControl]="!hasToProcessPointcloud() || !isEnabledNoiseReductionLevel">
                        <twc-select-option [value]="option.value" *ngFor="let option of edgeNoiseReductLevels">
                            {{ option.label| translate}}
                        </twc-select-option>
                    </twc-select>
                </div>


                <twc-checkbox class="twc-mt-4 filter-info">
                    <input twcCheckboxInput type="checkbox" formControlName="surfaceSmoothing"
                        [cwDisableControl]="isSurfaceSmoothingDisabled">
                    <label twcCheckboxLabel><span>{{'SCANPROC.SURFACE_SMOOTHING' | translate}}</span>
                        <twc-icon *ngIf="isSite()" shape="info"
                            twcTooltip="{{'SCANPROC_HELP.NOT_CRP1_SCANS' | translate}}" placement="right"
                            color="twc-topcon-blue">
                        </twc-icon>
                    </label>
                </twc-checkbox>

                <twc-checkbox *ngIf="isSite()" class="twc-mt-4 filter-info">
                    <input twcCheckboxInput type="checkbox" formControlName="strayFilter"
                        [cwDisableControl]="!hasToProcessPointcloud() || !areCrScansSelected()">
                    <label twcCheckboxLabel><span>{{'SCANPROC.STRAY_POINTS_FILTER' | translate}}</span>
                        <twc-icon shape="info" twcTooltip="{{'SCANPROC_HELP.ONLY_CRP1_SCANS' | translate}}"
                            placement="right" color="twc-topcon-blue">
                        </twc-icon>
                    </label>
                </twc-checkbox>

                <twc-checkbox *ngIf="isSite()" class="twc-mt-4 filter-info">
                    <input twcCheckboxInput type="checkbox" formControlName="autodetectTargets"
                        [cwDisableControl]="!hasToProcessPointcloud() || !areCrScansSelected()">
                    <label twcCheckboxLabel><span>{{'SCANPROC.AUTODETECT_TARGETS' | translate}}</span>
                        <twc-icon shape="info" twcTooltip="{{'SCANPROC_HELP.ONLY_CRP1_SCANS' | translate}}"
                            placement="right" color="twc-topcon-blue">
                        </twc-icon>
                    </label>
                </twc-checkbox>
            </div>

            <div class="twc-d-flex flex-direction-column twc-ml-4"
                *ngIf="scanProcessingOptionsService.scanProcessingForm.controls['autodetectTargets'].value">
                <div>
                    <twc-checkbox class="twc-mt-3 filter-info">
                        <input twcCheckboxInput type="checkbox" formControlName="autodetectCheckerboards">
                        <label twcCheckboxLabel><span>{{'FEATURE_PROPERTIES.Checkerboard' | translate}}</span>
                        </label>
                    </twc-checkbox>
                </div>

                <div class="spheres-radius-container">
                    <twc-checkbox class="twc-mt-3 filter-info">
                        <input twcCheckboxInput type="checkbox" formControlName="autodetectSpheres">
                        <label twcCheckboxLabel><span>{{'FEATURE_PROPERTIES.Sphere' | translate}}</span>
                        </label>
                    </twc-checkbox>

                    <div class="twc-mt-2 twc-ml-3"
                        *ngIf="scanProcessingOptionsService.scanProcessingForm.controls['autodetectSpheres'].value">
                        <cw-sphere-radius-chips [(chips)]="options.sphereSizes"></cw-sphere-radius-chips>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="!isDisabledColorizeAndPanorama">
                <div class="twc-mt-4">
                    <div><strong>{{'SCANPROC.COLORIZE' | translate}}</strong></div>

                    <twc-checkbox class="twc-mt-2">
                        <input twcCheckboxInput type="checkbox" formControlName="colorize"
                            [cwDisableControl]="!hasToProcessPointcloud()">
                        <label twcCheckboxLabel> {{'SCANPROC.COLORIZE' | translate}} </label>
                    </twc-checkbox>
                </div>


                <div class="twc-mt-4">
                    <div><strong>{{'SCANPROC.PANORAMA_STITCHING' | translate}}</strong></div>

                    <twc-checkbox class="twc-mt-2">
                        <input twcCheckboxInput type="checkbox" formControlName="processPanorama">
                        <label twcCheckboxLabel> {{'SCANPROC.PROCESS_PANORAMA' | translate}} </label>
                    </twc-checkbox>
                </div>

                <div class="twc-d-flex align-center">
                    <div class="twc-col-4 twc-mr-2">
                        <label class="twc-form-label">{{'SCANPROC.PANORAMA_RESOLUTION' | translate}}</label>
                        <twc-select [cwDisableControl]="!hasToProcessPanorama()" formControlName="resolution"
                            class="twc-col-3 twc-p-0">
                            <twc-select-option [value]="option.value" *ngFor="let option of panoramaResolution">
                                {{ option.label | translate}}
                            </twc-select-option>
                        </twc-select>
                    </div>

                    <div class="twc-col-4">
                        <label class="twc-form-label">{{'SCANPROC.PANORAMA_RADIUS' | translate}}</label>
                        <input class="twc-input twc-col-6" formControlName="radius" type="number" step="1"
                            [cwDisableControl]="!hasToProcessPanorama()">
                    </div>

                </div>
            </ng-container>

        </form>
    </div>

    <div *ngIf="hasToShowCreditEstimationMessage()" class="twc-mt-4 twc-message-box twc-message-box-warning">
        {{'SCANPROC.CREDIT_CANNOT_BE_ESTIMATED' | translate}}
    </div>

</div>